import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner automotive-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">ENTERTAINMENT</h2>
						<div className="red-border"> </div>
						<p>Unlock the world of interactions with our core solutions for entertainment industry catering from production to distribution.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
